export default function FooterEN() {
  return (
      <footer>
        <div className="max-w-7xl mx-auto px-6">
          <div className="pt-10 lg:pt-18">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-4/12">
                <div>
                  <a href="/en" className="mb-10 lg:mb-20 inline-block">
                    <img src="/images/logo/logo-square.webp" alt="CV Box Logo" className="h-25 w-auto object-contain" width={200} height={200} />
                  </a>
                  <p className="lg:pr-10 text-gray-500 text-base">
                    Build your professional profile, track jobs, and generate tailored application materials with AI. Get compatibility reports, optimized CVs, cover letters, and career coaching with Job Agent. Trusted by 1,200+ job seekers worldwide.
                  </p>
                </div>
              </div>
              <div className="lg:w-6/12 lg:ml-auto">
                <div className="grid grid-cols-2 gap-5 sm:gap-10 sm:grid-cols-3">
                  <div>
                    <h3 className="text-lg text-gray-800 font-medium mb-6">
                      Product
                    </h3>
                    <nav className="space-y-5">
                      <a
                          href="/en"
                          className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                      >
                        Home
                      </a>
                      <a
                          href="/en#features"
                          className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                      >
                        Features
                      </a>
                      <a
                          href="/en#pricing"
                          className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                      >
                        Pricing
                      </a>
                    </nav>
                  </div>
                  <div>
                    <h3 className="text-lg text-gray-800 font-medium mb-6">
                      Company
                    </h3>
                    <nav className="space-y-5">
                      <a
                          href="/en/contact"
                          className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                      >
                        Contact
                      </a>
                      <a href="/privacy" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Privacy Policy
                      </a>
                      <a href="/cookie" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Cookie Policy
                      </a>
                      <a href="/returns" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Returns Policy
                      </a>
                      <a href="/terms" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Terms of Service
                      </a>
                      <a href="/acceptable-use" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Acceptable Use Policy
                      </a>
                      <a href="/company" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Business Details
                      </a>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center pb-10 pt-10 lg:pt-20">
            <p className="text-base text-gray-500">
              © 2025 - {new Date().getFullYear()} CV Box. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
  );
}
